import type { CalibrationRuntimeData } from '@/features/calibration/hooks/useCalibrationRuntime/types';
import type { EquipmentStatus, WorkStatus } from '../types';

export const WORK_STATUS = {
  Complete: 'Complete',
  Incomplete: 'Incomplete',
  Backordered: 'Backordered',
  Skipped: 'Skipped',
  Unknown: 'Unknown'
} as const satisfies Record<WorkStatus, WorkStatus>;

export const EQUIPMENT_STATUS = {
  NotStarted: 'not-started',
  InProgress: 'in-progress',
  Complete: 'complete'
} as const satisfies Record<string, EquipmentStatus>;

export const CALIBRATION_STATUS = {
  NotStarted: 'not_started',
  InProgress: 'in_progress',
  Complete: 'complete'
} as const;

type CalibrationStatus =
  (typeof CALIBRATION_STATUS)[keyof typeof CALIBRATION_STATUS];

const CALIBRATION_TO_EQUIPMENT_STATUS: Record<
  CalibrationStatus,
  EquipmentStatus
> = {
  [CALIBRATION_STATUS.Complete]: EQUIPMENT_STATUS.Complete,
  [CALIBRATION_STATUS.InProgress]: EQUIPMENT_STATUS.InProgress,
  [CALIBRATION_STATUS.NotStarted]: EQUIPMENT_STATUS.NotStarted
};

const WORK_STATUS_MAP: Record<string, WorkStatus> = {
  Complete: WORK_STATUS.Complete,
  Incomplete: WORK_STATUS.Incomplete,
  Backordered: WORK_STATUS.Backordered,
  Skipped: WORK_STATUS.Skipped
};

export const determineWorkStatus = (
  detailStatus: string | undefined
): WorkStatus => {
  if (!detailStatus) return WORK_STATUS.Unknown;
  return WORK_STATUS_MAP[detailStatus] ?? WORK_STATUS.Unknown;
};

export const determineEventStatus = (
  calibrationData: CalibrationRuntimeData | null
): EquipmentStatus => {
  const status = calibrationData?.status?.calibration;
  if (!status) return EQUIPMENT_STATUS.NotStarted;
  return (
    CALIBRATION_TO_EQUIPMENT_STATUS[status as CalibrationStatus] ??
    EQUIPMENT_STATUS.NotStarted
  );
};

export const parseCalibrationData = (
  jsonData: string | null | undefined
): CalibrationRuntimeData | null => {
  if (!jsonData) return null;
  try {
    return JSON.parse(jsonData) as CalibrationRuntimeData;
  } catch {
    return null;
  }
};
